import React, { useEffect, useRef, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import AddEditModal from '../AddEditModal';
import ProductRow from '../../pages/listing/ProductRow';
import {
	toggleEditImageOptions,
	deleteProductImage,
	deleteProductVideo,
	updateProductMedia,
	updateProductPrice,
	setCurrentEditPage,
	restoreProductData,
	updateEditProductDetail,
	updateBrandedProduct,
	setHybridData,
	productUnderEdit
} from '../../actions/products';
// import { showToastMessage } from '../../actions/toastmessage';
import { addBackHandler, removeBackHandler } from '../historyHandler';
import ViewImageSlider from '../ViewImage/ViewImageSlider';
import EditImageOptions from '../EditImageOptions';
import UploadOptions from '../upload-options/UploadOptions';
import LinkUploadSlider from '../link-upload-slider/LinkUploadSlider';
import Modal from 'jd-library/Modal';
import Button from 'jd-library/Button';
import ButtonGroup from 'jd-library/ButtonGroup';
import styles from '../../pages/listing/product-row.scss';
import {otherThanEnglish} from '../../pages/add-edit-product/AddEditProduct'
import { toggleLibrarySlider } from '../../actions/videoLibrary';
import {checkLoggedIn, isBeyondRange, checkUomType} from '../../utills';
import {useHistory} from 'react-router-dom';
import UOMSliderWrapper from '../../pages/add-edit-product/UOMSliderWrapper';
import Switch from '../../common/switch/Switch';
import Loader from 'jd-library/Loader';
import toastMessageActions from 'jd-library/toastMessageActions'
import HideUnhideModal from '../../pages/add-edit-product/VariantModals/HideUnhideModal';
import CopyImagesSlider from '../UploadOptions/CopyImages/CopyImagesSlider';
import { resetBrandManufactureData, resetSpecificationFormData } from '../../actions/productSpecification';
import { resetVariantData } from '../../actions/variants';

const priceRegex = /^\d{0,10}(\.\d{0,2})?$/;

const ProductList = React.forwardRef((props,ref) => {
	const products = props.products;
	const [showAddEditPriceModal, toggleAddEditPriceModal] = useState(false);
	const [productPrice, setProductPrice] = useState('');
	const [actProductPrice, setActProductPrice] = useState('');
	const [discProductPrice, setDiscProductPrice] = useState('')
	const [isUomSliderOpen, toggleUomSlider] = useState(false);
	const [minProductPrice, setMinProductPrice] = useState(null);
	const [maxProductPrice, setMaxProductPrice] = useState(null);
	const [showPriceRange, togglePriceRange] = useState(false);
	const [autoFocus, setAutoFocus] = useState(false);
	const [expandedVariant, toggleExpanded] = useState(null);
	const [imageSliderVisible, updateViewImageSlider] = useState(null);
	const [noEdit, toggleNoEditModal] = useState(false);
	const [showDelBtn, toggleShowDelBtn] = useState(false);
	const [showModal, toggleModal] = useState(false);
	const [animateDirection, setAnimateDirection] = useState('');
	const prevScrollTop = useRef(null);
	const routerHistory = useHistory();
	const prodUnderEdit = useRef(null);
	const imageSlider = useRef(null);
	const sliderRef = useRef(null);
	const [errors,updateError] = useState({price:''});
	const [productUnit, updateUnit]= useState('');
	const [savedUom, updateSavedUom] = useState('');
	let [modalObj,setModalObj] = useState({});
	const [isService,setIsService] = useState(false);
	const [mrp, setMrp] = useState(null);
	const [sellingPrice, setSellingPrice] = useState(null);
	const [sellOnline, setSellOnline] = useState(null);
	const profileObject = props?.session?.profileObject;
	const brandedTab = (props.tabKey == 'brand');
	const [hideUnhideModalData,updateModalData] = useState({show: false})
	const [serviceCustomUom, setServiceCustomUom] = useState({ isCustom: false, type: "", value: "" })
	const serviceUOM = useSelector(state => state.uom.serviceUOM)	
	const [showBtnLoader, toggleBtnLoader] = useState(false);

	if(props.isAuditor && products[0] && products[0].productId == 'ADD_PRODUCT'){
		products.splice(0,1);
	}
	// let label = prodUnderEdit.current && prodUnderEdit.current.uom
	// 	? 'Product Price Per ' + prodUnderEdit.current.uom
	// 	: 'Product Price';
		const onSelectUOM = (e, uom) => {
			const key = 'unitOfMeasurement'
			let updateArr = [
				{
					key,
					value: uom.val,
					uomType: uom.uomType
				}
			];
			props.updateEditProductDetail(updateArr);
			// const newErrors = {...errors};
			// if(savedUom.uomType == 'LOOSE' && uom.uomType == 'PACKED') {
			// 	newErrors[key]= `Cannot Change	Unit of Measurement from Loose (`+savedUom.plural+`) to Packed (`+uom.plural+`)`
			// }
			// updateError(newErrors);
			updateUnit(uom);
			if (['sess', 'visit'].includes(uom.val.toLowerCase())) {
				setServiceCustomUom({ ...serviceCustomUom, isCustom: true, type: uom.val })
			}else{
				setServiceCustomUom({ ...serviceCustomUom, isCustom: false, type: uom.val })
			}
			sliderRef.current.openCloseUOMSlider(false);
			toggleUomSlider(false);
		};
	const inputObj = [{
		holderClass: styles['product-row'],
		formElements: [{
			hide: !showPriceRange || sellOnline,
			priceRange: true,
			holderClass: styles['marginLR15']+' '+styles['marginT20'],
			inputObj: [{
				label: 'Min. Price',
				key: 'minPrice',
				holderClass: 'min-price',
				input: {
					value: minProductPrice || '', //productData.minPrice || '',
					type: props.isIphone ? 'number' : 'tel',
					onChange: e => handleChange(e,'minPrice'),
					onFocus: e => handleFocus(e, 'minPrice')
				}

			},{
				label: 'Max. Price',
				key: 'maxPrice',
				holderClass: 'max-price',
				input: {
					value: maxProductPrice || '', //productData.maxPrice || '',
					type: props.isIphone ? 'number' : 'tel',
					onChange: e => handleChange(e,'maxPrice'),
					onFocus: e => handleFocus(e, 'maxPrice')
				}

			},{
				label: 'Unit',
				disableMovingLabel: true,
				key: 'unitOfMeasurement',
				holderClass: 'unit-measurement',
				showArrow: brandedTab || prodUnderEdit.current?.isTemplate ? false : true,
				input: {
					value: typeof productUnit === 'object' ? productUnit.displayVal : (productUnit || ''),
					//props.unitOfMeasurement.displayVal || '',
					//onChange: e => handleChange(e, 'unitOfMeasurement'),
					readOnly: true,
					//disabled: isTemplate,
					className: styles['range-unit-of-measurement'],
					disabled: brandedTab || prodUnderEdit.current?.isTemplate,
					onClick: () => {
						sliderRef.current.openCloseUOMSlider(true);
						toggleUomSlider(true);
					}
				},
				ignoreParentClass: true,
				editableForTemplate: true
			}],
			error: errors
		},
		{
			hide: !isService  || showPriceRange,
			priceRange: true,
			holderClass: styles['marginLR15']+' '+styles['marginT20'],
			inputObj: [
			{
				label: 'Act. Price',
				key: 'actPrice',
				holderClass: 'min-price',
				input: {
					value: actProductPrice || '',
					type: props.isIphone ? 'number' : 'tel',
					onChange: e => handleChange(e,'actPrice'),
					onFocus: e => handleFocus(e, 'actPrice')
				}

			},{
				label: 'Disc. Price',
				key: 'discPrice',
				holderClass: 'max-price',
				input: {
					value: discProductPrice || '',
					type: props.isIphone ? 'number' : 'tel',
					onChange: e => handleChange(e,'discPrice'),
					onFocus: e => handleFocus(e, 'discPrice')
				}

			},{
				label: 'Unit',
				disableMovingLabel: true,
				key: 'unitOfMeasurement',
				holderClass: 'unit-measurement',
				showArrow: brandedTab || prodUnderEdit.current?.isTemplate  ? false : true,
				input: {
					value: typeof productUnit === 'object' ? productUnit.displayVal : (productUnit || ''),
					readOnly: true,
					className: styles['range-unit-of-measurement'],
					disabled: brandedTab || prodUnderEdit.current?.isTemplate,
					onClick: () => {
						sliderRef.current.openCloseUOMSlider(true);
						toggleUomSlider(true);
					}
				},
				ignoreParentClass: true,
				editableForTemplate: true
			}
			],
			
			error: errors
		},

		{
			hide: isService || showPriceRange || sellOnline,
			label: `${isService ? 'Service' : 'Product'} Price`,
			prepend:() => <span className="icon-currency" />,
			hidePrependBar:true,
			key: 'price',
			holderClass: styles['prod-price'],
			input: {
				value: productPrice || '',
				type: props.isIphone ? 'number' : 'tel',
				onChange: e => handleChange(e, 'price'),
				onKeyDown : e => handleKeyDown(e),
				onFocus: e => handleFocus(e, 'price')
			},
			ignoreParentClass: true,
			inputGroupProps: {
				rightSection:()=>{
					return <span className="font-14" style={{color: "#717171"}}>Per</span>
				}
			},
		},
		{
			hide: isService || showPriceRange || sellOnline,
			label: 'Select Unit',
			disableMovingLabel: true,
			key: 'unitOfMeasurement',
			holderClass: `${errors.price != '' ? 'arrow-padding' : ''} ${brandedTab || prodUnderEdit.current?.isTemplate ? styles['prod-unit'] +' '+styles['branded-prod'] : styles['prod-unit']}`,
			errorClass: styles['prod-unit-error'],
			showArrow: brandedTab || prodUnderEdit.current?.isTemplate || (isService && (productUnit?.displayVal || productUnit))  ? false : true,
			rightIconClass : ((typeof productUnit === 'object' && productUnit.displayVal || productUnit) &&  !(brandedTab || prodUnderEdit.current?.isTemplate) && !props.isAuditor && isService) ? 'icon-HDRcross font10' : '',
			onRightIconClick : (e) => {
				onSelectUOM(e,'');
			},
			input: {
				value: typeof productUnit === 'object' ? productUnit.displayVal : (productUnit || ''),
				readOnly: true,
				className: styles['range-unit-of-measurement'],
				disabled: brandedTab || prodUnderEdit.current?.isTemplate ,
				// disabled: isTemplate,
				onClick: () => {
					sliderRef.current.openCloseUOMSlider(true);
					toggleUomSlider(true);
				}
			},
			ignoreParentClass: true,
			editableForTemplate: true
		},
	    {
			hide: sellOnline,
			customJSX: (
				<div className={`${styles['more-detail-switch']} ${errors['minPrice'] || errors['maxPrice'] ? styles['error-flag']: ''}`}>
					<Switch
						label='Add Price Range'
						labelPosition='before'
						labelTitleClass = {styles['price-range-label']}
						onClick={() => togglePriceRange(!showPriceRange)}
						checked={showPriceRange}
						showToggleStatus={false}
					/>
				</div>
			)
		},
		{
			hide: !sellOnline,
			priceRange: true,
			hideDash: true,
			doNotCenter: true,
			inputObj: [{
				label: 'MRP',
				key: 'mrp',
				holderClass: 'sell-online-price',
				errorClass: `${(errors[`mrp`] == "allSellFieldEmpty") ? 'hide-error-text' : ''}`,
				prepend:() => <span className="icon-currency" />,
			    hidePrependBar:true,
				input: {
					value: mrp || '', //productData.mrp || '',
					autoFocus: true,
					type: props.isIphone ? 'number' : 'tel',
					onChange: e => handleChange(e,'mrp'),
					onFocus: e => handleFocus(e, 'mrp'),
					className: props.isIphone || props.isMacOS ? styles['ios-input-label'] : ''
				}

			},{
				label: 'Selling Price',
				key: 'sellingPrice',
				holderClass: 'sell-online-price',
				errorClass: `${(errors[`sellingPrice`] == "allSellFieldEmpty") ? 'hide-error-text' : ''}`,
				prepend:() => <span className="icon-currency" />,
			    hidePrependBar:true,
				input: {
					value: sellingPrice || '', //productData.sellingPrice || '',
					type: props.isIphone ? 'number' : 'tel',
					onChange: e => handleChange(e,'sellingPrice'),
					onFocus: e => handleFocus(e, 'sellingPrice'),
					className: props.isIphone || props.isMacOS ? styles['ios-input-label'] : ''
				}

			}],
			error: errors
		},
		{
			hide: !sellOnline || (!(errors[`mrp`] == "allSellFieldEmpty") && !(errors[`sellingPrice`] == "allSellFieldEmpty")),
			customJSX:  (
				<div className={`${styles['custom-error-msg']}`}>
					{"Please Enter Price"}
				</div>
			)

		}
	]
	}];

	const handleKeyDown = (e) => {
		if(!props.isIphone){
			return;
		}
		const keycode = e.key;
		if(keycode == "Backspace"){
			return;
		}
		if(!keycode.match(/\d|\./g) || !((productPrice || "")+(keycode||'')).match(priceRegex)){
			e.preventDefault();
		}
	}

	const handleFocus = (e, key) => {
		const newErrors = { ...errors };
		newErrors[key] = '';
		updateError(newErrors);
	};

	const handleChange = (e, key) => {
		const curData = typeof event !== 'undefined' ? event.data : null;
		const value = e.target.value;
		if (otherThanEnglish.test(value) || !priceRegex.test(value)) {
			return;
		}

		switch (key) {
			case 'price': {
                 if(!priceRegex.test((productPrice || '') + (curData || ''))){
					return;
				 }
				 setProductPrice(e.target.value);
			}
			break;
			case 'actPrice' : {
				setActProductPrice(e.target.value);
			}
			break;
			case 'discPrice' : {
				setDiscProductPrice(e.target.value);
			}
			break;
			case 'minPrice': {
               setMinProductPrice(e.target.value);
			}
			break;
			case 'maxPrice': {
               setMaxProductPrice(e.target.value);
			}
			break;
			case 'mrp': {
				setMrp(e.target.value);
			}
			break;
			case 'sellingPrice': {
				setSellingPrice(e.target.value);
			}
			break;
		}
		//setProductPrice(e.target.value);
	};
	useEffect(() => {
		props?.session?.user?.loggedUser?.userType == "AUDITOR" ? window.scrollTo(0, 0) : null; 
		addBackHandler(closeSliderOnHardwareBack);
		return () => {
			removeBackHandler(closeSliderOnHardwareBack);
		};
	}, []);

	const openCloseAddEditPriceModal = (show) => {
		if(!show){
			updateUnit('');
			updateSavedUom('');
			updateError({price:''})
		}
        toggleAddEditPriceModal(show);
	}
	const openPriceModal = productData => {
		if(productData.type == 'service'){
			setIsService(true);
		}else {
			setIsService(false);
		}
		openCloseAddEditPriceModal(true);
		prodUnderEdit.current = productData;
		if(productData.isSellOnline){
			setSellOnline(true);
			setSellingPrice(productData.sellingPrice);
			setMrp(productData.mrp);
		}else{
			setSellOnline(false);
		}
		//refs253737
		if (false && prodUnderEdit.current && !prodUnderEdit.current.sellingPrice) {
			setProductPrice('');
		} else {
			const priceObj = prodUnderEdit.current.priceObj || {};
			if(priceObj.isSinglePrice){
				setProductPrice(priceObj.singlePrice);
				setDiscProductPrice(priceObj.singlePrice)
				setActProductPrice(priceObj.actualPrice)
				setMinProductPrice('');
				setMaxProductPrice('');
				togglePriceRange(false);
			}else{
				setMinProductPrice(priceObj.minPrice);
				setMaxProductPrice(priceObj.maxPrice);
				setProductPrice('');
				togglePriceRange(true);
			}
			//setProductPrice(prodUnderEdit.current.sellingPrice);
			if(productData.type == 'service'){
				const uomObj = checkUomType(prodUnderEdit.current.uom, serviceUOM)
				updateUnit(uomObj.value ? uomObj.obj : prodUnderEdit.current.uom);
				const isCustom = uomObj.value ? true : false
				setServiceCustomUom({ isCustom, type: uomObj.type, value: uomObj.value })
			}else{
				updateUnit(prodUnderEdit.current.uom);
			}
			updateSavedUom(prodUnderEdit.current.uomType);
		}
		setAutoFocus(true);
	};
	const toggleViewImageSlider = (flag, productId, selImageIndex,isTemplate, variantStatus, productData) => {
		if(variantStatus) {
			toggleNoEditModal(true);
			return;
		}
		prevScrollTop.current = window.scrollY;
		updateViewImageSlider({
			selImageIndex: selImageIndex,
			productId: productId,
			type: productData.type,
			from: 'listing',
			isTemplate: isTemplate,
			keywordId: productData.keywordId,
			updateScrollPos: val => prevScrollTop.current = val
		});
		// imageSlider.current.toggleSlider(flag, productId, selImageIndex,isTemplate);
		//history.pushState({ state: 'viewImageSlider-modal' }, '');
	};
	const onPriceUpdate = e => {
		e.stopPropagation;
		if (showBtnLoader) {
			return;
		}
		toggleBtnLoader(true);
		const newErrors = { ...errors };
		let isError = false;
		const priceObj = {...prodUnderEdit.current.priceObj};
		priceObj.isSinglePrice = !showPriceRange;
		priceObj.singlePrice = isService ? discProductPrice : productPrice ;
		priceObj.minPrice = minProductPrice;
		priceObj.maxPrice = maxProductPrice;
		priceObj.actualPrice = actProductPrice;
		priceObj.mrp = mrp;
		priceObj.sellingPrice = sellingPrice;
		if (priceObj.isSinglePrice && isService){
			let errorField = '',errorMsg='';
			 if ((priceObj.singlePrice && priceObj.singlePrice == 0) || (priceObj.actualPrice && priceObj.actualPrice == 0)) {
				errorMsg = (priceObj.singlePrice && Number(priceObj.singlePrice) === 0) ? 'Disc. Price Cannot be 0' : 'Actual. Price Cannot be 0';
				isError = true;
				if (priceObj.singlePrice && Number(priceObj.singlePrice) == 0) {
					newErrors['discPrice'] = errorMsg;
					newErrors['actPrice'] = false;
				} else if (priceObj.actualPrice == 0) {
					newErrors['actPrice'] = errorMsg;
					newErrors['discPrice'] = false;
				}
			} else if ((priceObj.singlePrice && Number(priceObj.singlePrice) < 0.01) || (priceObj.actualPrice && Number(priceObj.actualPrice) < 0.01)) {
				errorMsg = Number(priceObj.singlePrice) < 0.01 ? 'Disc. Price must be at least 0.01' : 'Actual Price must be at least 0.01';
				isError = true;
				if (priceObj.singlePrice && Number(priceObj.singlePrice) < 0.01) {
					newErrors['discPrice'] = errorMsg;
					newErrors['actPrice'] = false;
				} else if (priceObj.actualPrice && Number(priceObj.actualPrice) < 0.01) {
					newErrors['actPrice'] = errorMsg;
					newErrors['discPrice'] = false;
				}
			} else if (priceObj.singlePrice !== '' && priceObj.actualPrice !== '') {
				if ((Number(priceObj.singlePrice) > Number(priceObj.actualPrice) && priceObj.actualPrice != 0)) {
					errorMsg = 'Cannot be More than Actual Price';
					isError = true;
					newErrors['discPrice'] = errorMsg;
					newErrors['actPrice'] = false;
				}
				if (priceObj.actualPrice && Number(priceObj.actualPrice) < 0.01) {
					errorMsg = "Actual Price must be at least 0.01";
					isError = true;
					newErrors['actPrice'] = errorMsg;
				}
				if (Number(priceObj.singlePrice) < 0.01) {
					errorMsg = "Disc. Price must be at least 0.01";
					isError = true;
					newErrors['discPrice'] = newErrors['actPrice'] ? true : errorMsg;
				}
			}
		}else if(!priceObj.isSinglePrice && !sellOnline){
			let errorField = '',errorMsg='';
            if(!priceObj.minPrice || !priceObj.maxPrice){
				errorMsg = !priceObj.minPrice?'Enter Min. Price':'Enter Max. Price';
				errorField = !priceObj.minPrice?'minPrice':'maxPrice';
				isError = true;
				if(errorField == 'minPrice'){
					newErrors[errorField] = errorMsg;
					newErrors['maxPrice'] = false;
				}else if(errorField == 'maxPrice'){
					 newErrors[errorField] = errorMsg;
					 newErrors['minPrice'] = false;
				}
			}else if((priceObj.minPrice && priceObj.minPrice == 0) || (priceObj.maxPrice && priceObj.maxPrice == 0)){
				errorMsg = priceObj.minPrice == 0?'Min. Price Cannot be 0':'Max. Price Cannot be 0';
				isError = true;
				if(priceObj.minPrice == 0){
					newErrors['minPrice'] = errorMsg;
					newErrors['maxPrice'] = false;
				}else if(priceObj.maxPrice == 0){
					newErrors['maxPrice'] = errorMsg;
					newErrors['minPrice'] = false;
				}
			}else if((priceObj.minPrice && Number(priceObj.minPrice) < 0.01) || (priceObj.maxPrice && Number(priceObj.maxPrice) < 0.01)){
				errorMsg = Number(priceObj.minPrice) < 0.01 ? 'Min. Price must be at least 0.01':'Max. Price must be at least 0.01';
				isError = true;
				if(priceObj.minPrice && Number(priceObj.minPrice) < 0.01){
					newErrors['minPrice'] = errorMsg;
					newErrors['maxPrice'] = false;
				}else if(priceObj.maxPrice < 0.01){
					newErrors['maxPrice'] = errorMsg;
					newErrors['minPrice'] = false;
				}
			}else if(priceObj.minPrice !== '' && priceObj.maxPrice !== ''){
				if(Number(priceObj.minPrice) > Number(priceObj.maxPrice)){
					errorMsg = 'Cannot be More than Max. Price';
					isError = true;
					newErrors['minPrice'] = errorMsg;
					newErrors['maxPrice'] = false;
				}else if(Number(priceObj.minPrice) == Number(priceObj.maxPrice)) {
					errorMsg = 'Max. Price Cannot be Same or Less Than Min. Price';
					isError = true;
					newErrors['minPrice'] = errorMsg;
					newErrors['maxPrice'] = true;
				}
			}
		}else {
			let errorField = '',errorMsg='',toastMsg = '';
			if(!priceObj.mrp && priceObj.mrp != 0 && priceObj.sellingPrice != 0 && !priceObj.sellingPrice && sellOnline){
				isError = true;
				newErrors['mrp'] = 'allSellFieldEmpty';
				toastMsg = 'Please Enter the Price'
				newErrors['sellingPrice'] = 'allSellFieldEmpty';
			}else{
				if(!isService && priceObj.singlePrice && priceObj.singlePrice == 0){
					errorMsg = 'Cannot be 0'
					isError = true;
					toastMsg = 'Price Value Cannot be 0';
					newErrors['price'] = errorMsg;
				}else if(!isService && !priceObj.singlePrice && sellOnline){
					let msg = 'Please Enter Price'
					newErrors['price'] = msg;
					if(!errorField){
						errorField = msg;
					}
				}else if(!isService && priceObj.singlePrice && Number(priceObj.singlePrice) < 0.01){
					errorMsg = 'Invalid Price';
					isError = true;
					toastMsg = 'Price Value must be at least 0.01';
					newErrors['price'] = errorMsg;
				}

				if(priceObj.sellingPrice == 0){
					errorMsg = 'Cannot be 0'
					isError = true;
					if(!toastMsg){
						toastMsg = 'Selling Price Value Cannot be 0';
					}
					newErrors['sellingPrice'] = errorMsg;
				}else if(!priceObj.sellingPrice && sellOnline){
					errorMsg = 'Please Enter Selling Price'
					isError = true;
					newErrors['sellingPrice'] = errorMsg;
				}else if(priceObj.sellingPrice && Number(priceObj.sellingPrice) < 0.01){
					errorMsg = 'Invalid Selling Price';
					isError = true;
					if(!toastMsg){
						toastMsg = 'Selling Price Value must be at least 0.01';
					}
					newErrors['sellingPrice'] = errorMsg;
				}else if(priceObj.mrp && (Number(priceObj.sellingPrice) > Number(priceObj.mrp))){
					errorMsg = 'Higher than MRP';
					isError = true;
					if(!toastMsg){
						toastMsg = 'Selling Price is Higher than MRP';
					}
					newErrors['sellingPrice'] = errorMsg;
				}

			}
			if(toastMsg){
				props.showToastMessage({
					showToastMessage: true,
					message: toastMsg,
					duration: 3000,
					type: 'error'
				});
			}
		}
		if (isError) {
			updateError(newErrors);
			toggleBtnLoader(false);
			return;
		}
		if(brandedTab){
			let data = {...prodUnderEdit.current};
			data.priceObj = priceObj;
			props.updateBrandedProduct({
				productData : data,
				cb : () => {
					toggleBtnLoader(false);
					console.log("price updated")
				}
			})
		}else{
			if(priceObj && !priceObj.isSinglePrice && priceObj.maxPrice && priceObj.minPrice && (priceObj.minPrice == priceObj.maxPrice)){
				priceObj.isSinglePrice = true;
				priceObj.singlePrice = priceObj.minPrice;
			}
			if (isService && ((priceObj && !priceObj.actualPrice) || (priceObj && !priceObj.singlePrice))) {
				if (!priceObj.actualPrice){
					priceObj.actualPrice = priceObj.singlePrice
				}else if (!priceObj.singlePrice){
					priceObj.singlePrice = priceObj.actualPrice
				}
			}
			props.updateProductPrice({
				...prodUnderEdit.current,
				token: props.session.token,
				editFlag: prodUnderEdit.current.isSellingPrice || prodUnderEdit.current?.isSellOnline ? 'edit' : 'add',
				priceObj: priceObj,
				//price: productPrice || 0,
				uom: serviceCustomUom.isCustom ? `${serviceCustomUom.value} ${serviceCustomUom.type}` : productUnit?.val ?? savedUom?.val ?? '',
				isSellOnline: sellOnline,
				cb: () => {
					let listingData = {};
					if(props.tabKey){
						listingData.tabKey = props.tabKey
					}
					props.getListingData({listingData,filterObj:props.listing.filterObj});
					toggleBtnLoader(false);
					onModalClose();
					props.showToastMessage({
						showToastMessage: true,
						message: 'Price Updated Successfully',
						duration: 5000
					});
				},
				cbError: (minPrice, maxPrice, msg) => {
					toggleBtnLoader(false);
					let possibleFields = [];
					if (priceObj.singlePrice && !showPriceRange) {
						if (priceObj.singlePrice){
							if (isBeyondRange(priceObj.singlePrice, minPrice, maxPrice)) {
								possibleFields.push('price');
							}
						}else {
							if (isBeyondRange(priceObj.actualPrice, minPrice, maxPrice)) {
								possibleFields.push('actPrice');
							}
							if (isBeyondRange(priceObj.singlePrice, minPrice, maxPrice)) {
								possibleFields.push('discPrice');
							}					  
						}
					} else {
						if (isBeyondRange(priceObj.minPrice, minPrice, maxPrice)) {
							possibleFields.push('minPrice');
						}
						if(isBeyondRange(priceObj.maxPrice, minPrice, maxPrice)) {
							possibleFields.push('maxPrice');
						}
					}
					if (possibleFields.length) {
						props.showToastMessage({
							message: msg,
							type: "error",
							showReduxToast: true,
							duration: 5000
						});
						let errObj = {};
						possibleFields.forEach(fname => {
							errObj[fname] = possibleFields[0]==fname ? msg : true;
						})
						if (errObj) {
							updateError(errObj);  
						}
					}

				}
			});
		}
	};
	const onModalClose = (e, flag) => {
		// openCloseAddEditPriceModal(false);
		history.back();
		prodUnderEdit.current = null;
	};
	const closeSliderOnHardwareBack = () => {
		// updateViewImageSlider(null);
		//for hardback
		if(props.isMobile){
			props.updateEditProductDetail([{key: 'specification',value: []}])
			props.resetBrandManufactureData();
			props.setHybridData("");
			props.resetSpecificationFormData(true);
			props.resetVariantData();
		}
		setTimeout(() => {
			if(prevScrollTop.current) {
				window.scrollTo(0, prevScrollTop.current);
			}
			prevScrollTop.current = null;
			// imageSlider.current.toggleSlider(false, null, []);
		})
	};
	const onUomSliderClose = () => {
		toggleUomSlider(false);
	}
	useEffect(() => {
		if(props.animateDirection){
			setAnimateDirection(props.animateDirection);
			setTimeout(() => {
				setAnimateDirection('');
			}, 300);
		}
	}, [props.animateDirection, props.slideAgain]);
	let fakeProducts = products.length > 4 ? products.slice(0,4) : products;
	const closeCB = () => {
		props.sliderCloseCB && props.sliderCloseCB();
	}

	return (
		<>
			<div className={`prod-list ${animateDirection}`} ref={ref}>
				{products?.map((product, index) => {
					let key = product?.productId;
					if(key === 'ADD_PRODUCT'){
						key += index
					}
					return (
						<ProductRowMemo
							expanded={product?.productId === expandedVariant}
							toggleExpanded={toggleExpanded}
							key={key}
							openPriceModal={openPriceModal}
							onImageClick={props.isAuditor ? null : toggleViewImageSlider}
							productId={product?.productId}
							imageSliderVisible={imageSliderVisible}
							productUnderEdit={props.productUnderEdit.productId}
							toggleNoEditModal={toggleNoEditModal}
							toggleModal={toggleModal}
							pageType={props.pageType}
							getModalObj = {setModalObj}
							searchText = {props.searchText}
							confirmDelete={props.confirmDelete}
							isAuditor={props.isAuditor}
							readOnlyProduct={props.readOnlyProduct}
							onProductClick={props.onProductClick}
							onlyForSelection={props.onlyForSelection}
							isSpecialContract={props.isSpecialContract}
							toggleRequestTakeLive = {props.toggleRequestTakeLive}
							toggleActivateDeactivateModal ={props.toggleActivateDeactivateModal}
							objectionableMode={props.objectionableMode}
							fromSelectProductSlider={props.fromSelectProductSlider}
							index={index}
							isDummyProductRow = {product?.isDummyProductRow}
							updateModalData={updateModalData}
							isFromActionCard={props.isFromActionCard}
							slidertype={props?.sliderName?.slidertype}
							updateObjectionModal={props.updateObjectionModal}
						/>
					);
				})}
				{props.bottomLoader ? <div style={{height :"5.625rem", width: "100%", display: "flex", alignItems: "center", justifyContent: "center"}} >
							<div style = {{padding: "0.313rem", borderRadius: "100%", boxShadow: "rgba(0, 0, 0, 0.2) 0px 1px 15px 0px"}} >
								<Loader
									style ={{borderColor: "#3B74A9", borderTopColor: "white", height: "1.25rem", width: "1.25rem"}}
								/>
							</div>
						</div> : null}
			</div>
			{animateDirection &&
				<div className={`fake-prod-list ${animateDirection} ${props.noVendorImages ? '' : 'handle-vendor-images'} ${props.topPosClass}`}>
					{fakeProducts.map(product => {
						return (
							<ProductRowMemo
								expanded={product.productId === expandedVariant}
								toggleExpanded={toggleExpanded}
								key={product.productId}
								openPriceModal={openPriceModal}
								onImageClick={toggleViewImageSlider}
								productId={product.productId}
								productUnderEdit={props.productUnderEdit.productId}
								toggleNoEditModal={toggleNoEditModal}
								toggleModal={toggleModal}
								getModalObj = {setModalObj}
								searchText = {props.searchText}
								confirmDelete={props.confirmDelete}
								fromSelectProductSlider={props.fromSelectProductSlider}
								isAuditor={props.isAuditor}
								isSpecialContract={props.isSpecialContract}
								toggleRequestTakeLive = {props.toggleRequestTakeLive}
								toggleActivateDeactivateModal = {props.toggleActivateDeactivateModal}
								isDummyProductRow = {product.isDummyProductRow}
								isFromActionCard={props.isFromActionCard}
								slidertype={props?.sliderName?.slidertype}
							/>
						);
				})}
				</div>
			}
			{imageSliderVisible && <ViewImageSlider
				ref={imageSlider}
				canUploadImage={true}
				updateProductImage={props.updateProductMedia}
				deleteProductImage={props.deleteProductImage}
				deleteProductVideo={props.deleteProductVideo}
				restoreProductData={props.restoreProductData}
				toggleLibrarySlider={props.toggleLibrarySlider}
				showToastMessage={props.showToastMessage}
				showUndoToast
				checkLoggedIn={checkLoggedIn}
				b2bGenio={props.session.showCompanyDetails}
				routerHistory= {routerHistory}
				closeCB={closeCB}
				session={props.session}
				showAddImageWithText
				productListViewImageSlider={props.session.source === 'b2b'}
				onHidden={() => updateViewImageSlider(null)}
				{...imageSliderVisible}
			/>}
			{props.editImageOptions && (
				<EditImageOptions
					{...props.editImageOptions}
					toggleEditImageOptions={props.toggleEditImageOptions}
					toggleViewImageSlider={toggleViewImageSlider}
					deleteProductImage={props.deleteProductImage}
					deleteProductVideo={props.deleteProductVideo}
					supplierId={props.session.supplierId}
					updateProductMedia={props.updateProductMedia}
				/>
			)}
			{showAddEditPriceModal &&
				<AddEditModal
					onPriceUpdate={onPriceUpdate}
					showBtnLoader={showBtnLoader}
					onModalClose={onModalClose}
					inputObj={inputObj}
					openCloseAddEditPriceModal = {openCloseAddEditPriceModal}
					productUnderEdit={prodUnderEdit.current}
					errors={errors}
					isUomSliderOpen = {isUomSliderOpen}
					isSearchSliderOpen={props.isSearchSliderOpen}
			/> }
			<UploadOptions prodFromListing={true} />
			{!props.ignoreLinkSlider ? 
			<LinkUploadSlider
				source={props.session.source}
				tabKey={props.tabKey}
			/> : null}
			<CopyImagesSlider />
			{showDelBtn &&
				<div className='del-btn-wrapper'>
					<ButtonGroup>
						<Button
							variant="default"
							className='del-options no-del'
							clickHandler={() => { deleteBtnClick(false) }}
						>
							Don’t Delete
						</Button>
						<Button
							className='del-options del'
							clickHandler={() => { deleteBtnClick(true) }}
						>
							{`Delete  +  ${profileObject?.PluralLabelWithSpace}`}
						</Button>
					</ButtonGroup>
				</div>
			}
			{noEdit ? <Modal
				onHidden={() => toggleNoEditModal(false)}
                settings={{variant:styles['noedit-modal']+ ' action'}}>
				<Modal.CloseIcon
				/>
                <Modal.Body className={styles['noedit-modal-body']}>
                    <span>Currently Editing Products with Variants is Not Supported on Mobile. Please Use Our Web Application for the Same</span>
                </Modal.Body>
				<Modal.Footer>
					<Modal.Button clickHandler={()=> toggleNoEditModal(false)}>Okay, Got It</Modal.Button>
				</Modal.Footer>
                </Modal>
					: ''}
			{ showModal ? <Modal
				onHidden={() => toggleModal(false)}
				settings={{variant:'action '+styles['confirm-share-modal']}}>
					<Modal.CloseIcon />
					<Modal.Header>Unhide Product to Share?</Modal.Header>
					<Modal.Body>
						<span>Product need to be Unhidden before it can be shared.</span>
					</Modal.Body>
					<Modal.Footer>
						<Modal.Button variant="secondary" clickHandler={() => modalObj.onNoClick()}>No, Don't Unhide</Modal.Button>
						<Modal.Button clickHandler={() => modalObj.onYesClick()}>Yes, Unhide & Share</Modal.Button>
					</Modal.Footer>
			</Modal>
				: ''
			}
			<UOMSliderWrapper
				ref={sliderRef}
				uomType={isService ? 'serviceUOM' : 'productUOM'}
				onSelectUOM={onSelectUOM}
				showUOMType={'Packed'}
				onUomSliderClose = {onUomSliderClose}
				isMobile = {props.isMobile}
				priceModal={true}	
				productUnderEdit={prodUnderEdit.current}
			/>
			{hideUnhideModalData.show?
				<HideUnhideModal action={hideUnhideModalData.action} onHidden={() => updateModalData({show: false})} onHideUnhide={hideUnhideModalData.onHideUnhide} isService={hideUnhideModalData.isService} />
			:null}
		</>
	);
});
const mapStateToProps = (state, props) => {
	return {
		...props,
		noVendorImages: !state.products.vendorImages || !state.products.vendorImages.length,
		listing: state.products.listing,
		session: state.session,
		editImageOptions: state.products.editImageOptions,
		productUnderEdit: state.products.productUnderEdit,
		isIphone: state.deviceData.isIphone,
		isMobile: state.deviceData.isMobile,
		tabKey:state.products.tabKey,
		isMacOS: state.deviceData.isMacOS,
		isSearchSliderOpen: state.products.isSearchSliderOpen,
		dummyState: state // check not required then remove
	};
};

export default connect(mapStateToProps, {
	toggleEditImageOptions,
	deleteProductImage,
	updateProductMedia,
	deleteProductVideo,
	showToastMessage: toastMessageActions.showMessage,
	updateProductPrice,
	setCurrentEditPage,
	toggleLibrarySlider,
	updateEditProductDetail,
	restoreProductData,
	updateBrandedProduct,
	resetBrandManufactureData,
	setHybridData,
	resetSpecificationFormData,
	resetVariantData
},null,{forwardRef:true})(ProductList);

const ProductRowMemo = React.memo((props) => {
	return (
		<ProductRow
			openPriceModal={props.openPriceModal}
			onImageClick={props.onImageClick}
			productId={props.productId}
			isProductUpdated={props.productUnderEdit === props.productId}
			expanded={props.expanded}
			imageSliderVisible={props.imageSliderVisible}
			toggleExpanded={props.toggleExpanded}
			toggleNoEditModal={props.toggleNoEditModal}
			toggleModal={props.toggleModal}
			pageType={props.pageType}
			getModalObj={props.getModalObj}
			searchText={props.searchText}
			confirmDelete={props.confirmDelete}
			isAuditor={props.isAuditor}
			isSpecialContract={props.isSpecialContract}
			readOnlyProduct={props.readOnlyProduct}
			onlyForSelection={props.onlyForSelection}
			onProductClick={props.onProductClick}
			toggleRequestTakeLive = {props.toggleRequestTakeLive}
			toggleActivateDeactivateModal = {props.toggleActivateDeactivateModal}
			objectionableMode={props.objectionableMode}
			fromSelectProductSlider={props.fromSelectProductSlider}
			index={props.index}
			isDummyProductRow = {props.isDummyProductRow}
			updateModalData = {props.updateModalData}
			popoverClass={'listing-img-popover'}
			isFromActionCard={props?.isFromActionCard || false}
			slidertype={props?.slidertype || ""}
			updateObjectionModal={props.updateObjectionModal}
		/>
	);
}, (prevProps, nextProps) => {
	return nextProps.productUnderEdit != nextProps.productId && prevProps.expanded === nextProps.expanded && nextProps.searchText === prevProps.searchText;
})